import * as React from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import logosPreview from './logosPreview.jpg'
import officePreview from './officePreview.png'
import peoplePreview from './peoplePreview.png'
import Button from '../../../../components/button'
import productsPreview from './productsPreview.jpg'

import styles from './images.module.scss'

const sections: { heading: React.ReactNode; image: string; link: string }[] = [
  {
    heading: <FormattedMessage defaultMessage="Logotyper" id="press.images.logos.heading" />,
    link: '/assets/logos',
    image: logosPreview,
  },
  {
    heading: <FormattedMessage defaultMessage="Kontor" id="press.images.office.heading" />,
    link: '/assets/office',
    image: officePreview,
  },
  {
    heading: <FormattedMessage defaultMessage="Vår VD Sam Nurmi" id="press.images.people.heading" />,
    link: '/assets/people',
    image: peoplePreview,
  },
  {
    heading: <FormattedMessage defaultMessage="Produkter" id="press.images.products.heading" />,
    link: '/assets/products',
    image: productsPreview,
  },
]

export default function Images() {
  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <FormattedMessage defaultMessage="Bildmaterial" id="press.images.heading" tagName="h2" />
          <FormattedMessage
            defaultMessage="Använd bilderna nedan på Dooer-teamet, vår VD, produkter, logotyper och ikoner, givetvis ansvarsfullt, och ange gärna Dooer som källa. Informera lämpligen oss om något publiceras, dela länken med oss om det sker online."
            id="press.images.lede"
            tagName="p"
          />

          <div className={styles.imageSections}>
            {sections.map((section) => (
              <Section key={section.image} {...section} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

interface ISectionProps {
  heading: React.ReactNode
  link: string
  image: string
}

const Section = ({ heading, link, image }: ISectionProps) => (
  <Link className={styles.imageSection} to={link}>
    <h3>{heading}</h3>
    <div className={styles.image} style={{ backgroundImage: `url(${image})` }} />
    <Button variant="link">
      <FormattedMessage defaultMessage="Ladda ned bilderna här" id={`press.images.section--button`} />
    </Button>
  </Link>
)
